export var PathwaysError = function (message) { return "Pathways Error: " + message; };
export var PathwaysAPIError = function (message, response) { return ({
    message: "Pathways API Error: " + message,
    response: response,
}); };
//# sourceMappingURL=utils.js.map